import { useContext } from "react";
import { LuxeContext } from "@context/LuxeProvider";
import { useAuth } from "@context/AuthProvider";
import { getLuxeGiftInfo } from "@helpers/luxe";
import LuxeGiftEligibilityProgressBar from "@components/luxeGift/LuxeGiftEligibilityProgressBar";
import LuxeGiftCountdown from "@components/luxeGift/LuxeGiftCountdown";
import LuxeGiftProduct from "@components/luxeGift/LuxeGiftProduct";

function LuxeGift() {
  const { accountDetails } = useAuth();
  const { luxe } = useContext(LuxeContext);
  const luxeGiftPeriod = getLuxeGiftInfo(luxe, accountDetails?.tags);

  if (!["locked", "unlocked"].includes(luxeGiftPeriod?.status)) {
    return null;
  }

  return (
    <div className="relative w-full bg-light-grey px-[15px] py-[20px] desktop:p-[25px]">
      <div className="flex flex-col">
        <span className="typo-micro bold bg-black text-white py-[3px] px-[7px] rounded-[4px] w-fit mb-[10px] desktop:mb-[15px]">
          MEMBERS-ONLY GIFT
        </span>
        <p className="title-m desktop:title-s mb-[10px] desktop:mb-[12px]">
          Free Daily Case ($40 Value)
        </p>
        <p className="typo-body">Members unlock a free gift after 2 months of membership.</p>
      </div>
      <div className="flex flex-col desktop:flex-row gap-[10px] desktop:gap-[15px] mt-[20px] desktop:mt-[25px]">
        <div className="desktop:flex-1 desktop:justify-between flex flex-col gap-[10px] desktop:gap-[15px]">
          <LuxeGiftEligibilityProgressBar />
          <LuxeGiftCountdown />
        </div>
        <LuxeGiftProduct />
      </div>
    </div>
  );
}

export default LuxeGift;
